import React, { useEffect, useState } from "react";
import style from "./Documents.module.css";
import VendorUpload from "../../../CommonComponents/VendorUpload/VendorUpload";
import { Grid } from "@mui/material";

const uploadFileArray = [
  "Upload PAN",
  "Kyc",
  "Upload GST",
  "Upload Vendor Profile",
  "Upload Company Reg. Doc.",
  "Owner’s Photo",
  "HE Vendor Agreement",
  "Other",
];
const options = {
  label: "Select Kyc",
  values: [
    "Aadhaar",
    "Utility Bill",
    "Passport",
    "Voter ID",
    "Firm AOA",
    "Firm MOA",
    "Firm Reg. Cert.",
  ],
};

function Documents({
  setIsBtn1Active,
  setIsBtn2Active,
  saveClicked,
  finishClicked,
  onSaveClick,
  onFinishClick,
}) {
  const [uploadedDocuments, setUploadedDocuments] = useState({});
  const [selectValue, setSelectValue] = useState("");

  const onchangeHandler = (e, label) => {
    const file = e?.target?.files[0];
    if (file) {
      setUploadedDocuments((prevDocuments) => {
        const updatedDocuments = { ...prevDocuments };
        if (updatedDocuments[label]) {
          updatedDocuments[label] = {
            selectValue: label === "Kyc" ? selectValue : null,
            filename: file.name,
            fileUrl: URL.createObjectURL(file),
          };
        } else {
          updatedDocuments[label] = {
            selectValue,
            filename: file.name,
            fileUrl: URL.createObjectURL(file),
          };
        }
        return updatedDocuments;
      });
    }
  };

  const handleSelect = (e) => {
    setSelectValue(e?.target?.value);
  };

  useEffect(() => {
    if (saveClicked) onSaveClick();
    if (finishClicked) onFinishClick();
  }, [saveClicked, finishClicked]);
  return (
    <div style={{ marginTop: "2rem", marginLeft: "1rem" }}>
      <div>
        <div className={style["document_container"]}>
          <p className={style["uplaod_doument_header"]}>
            Upload Documents <span style={{ color: "red" }}>*</span>
          </p>
          <Grid
            container
            columnSpacing={10}
            sx={{
              //   display: "flex",
              //   flexWrap: "wrap",
              //   gap: "10px",
              marginTop: "1.5rem",
            }}
          >
            {uploadFileArray?.map((label, index) => {
              return (
                <Grid
                  item
                  key={label}
                  md={12}
                  lg={4}
                  style={{
                    // flex: "0 0 calc(33% - 10px)",
                    // maxWidth: "calc(33% - 10px)",
                    marginBottom: "1.25rem",
                  }}
                >
                  <VendorUpload
                    onChangeHandler={(e) => onchangeHandler(e, label)}
                    label={label}
                    placeholder={options?.label}
                    uploadedDocuments={uploadedDocuments}
                    onlyIcon={label === "Kyc" ? true : false}
                    options={options?.values}
                    onSelect={handleSelect}
                    value={selectValue}
                    disabled={selectValue?.length ? false : true}
                    uploadedImg={true}
                    viewImg={true}
                  />
                </Grid>
              );
            })}
          </Grid>
        </div>
      </div>
    </div>
  );
}

export default Documents;
